//
//
//
//
//
//
//
//
//
//
//
//
//

import uiShare from '@/component/uiShare'

export default {
  components: {
    uiShare
  },
  data () {
    return {
      have: Number(this.$route.params.have),
      openUrl: `${window.location.origin}${window.location.pathname}#/shangtang/detail/0`
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/shangtang/downMylink.vue